import { getAgentById } from '@nemuru-eng/js-api-client';
import { useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';

import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';

export const AgentPageTitle = () => {
  const {
    state: { loading },
    actions: pageActions,
  } = usePageContext();

  const { agentId } = useParams();

  if (!agentId) return null;

  const { data: agent, loading: agentLoading } = useCache(getAgentById, { agentId });

  const title = agent?.name || '';

  useSetPageLoadingWhenRequesting('AGENT_DETAILS', [agentLoading]);

  useLayoutEffect(() => {
    pageActions.setCustomTitle(title);
  }, [title, loading]);

  return <> </>;
};
